import {
    SAILS_BNT_STORAGE,
    SAILS_PARAM_ATOMIC_ID,
} from '@vfde-fe/sails-constants';
import {
    getSessionStorageItemJson,
    getURLParam,
} from '@vfde-fe/sails_core';
import { SailsHardwareDetailsStorage } from 'app/container/DeviceDetail/interfaces/storage';

/**
 * Get Atomic Id
 */
export const getAtomicId = (): number | null => {
    return getAtomicIdFromUrl() ?? getAtomicFromStorage();
};

const getAtomicIdFromUrl = (): number | null => {
    const atomicId = getURLParam(SAILS_PARAM_ATOMIC_ID);

    if (atomicId) {
        return parseInt(atomicId, 10);
    }

    return null;
};

const getAtomicFromStorage = (): number | null => {
    const storage = getSessionStorageItemJson<SailsHardwareDetailsStorage | null>(SAILS_BNT_STORAGE);
    const atomicId = storage?.[SAILS_PARAM_ATOMIC_ID];

    if (typeof atomicId === 'boolean') {
        return null;
    }

    if (typeof atomicId === 'string') {
        return parseInt(atomicId, 10) || null;
    }

    return atomicId || null;
};
